'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _streamUnwrap = require('../utils/streamUnwrap');

var _streamStatus = require('../loggers/streamStatus');

var _logCategoryActionLabel = require('../loggers/logCategoryActionLabel');

var _logCategoryActionLabel2 = _interopRequireDefault(_logCategoryActionLabel);

var _logging = require('../player/constants/logging');

var _debugger = require('../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

var _isHttpStream = require('../utils/isHttpStream');

var _isHttpStream2 = _interopRequireDefault(_isHttpStream);

var _listenTime = require('../loggers/listenTime');

var _listenTime2 = _interopRequireDefault(_listenTime);

var _streamProcessor = require('../streamProcessor');

var _streamProcessor2 = _interopRequireDefault(_streamProcessor);

var _streamMapper = require('../streamMapper');

var _streamMapper2 = _interopRequireDefault(_streamMapper);

var _cancelable = require('../utils/cancelable');

var _cancelable2 = _interopRequireDefault(_cancelable);

var _playerName2 = require('../player/constants/playerName');

var _playerName3 = _interopRequireDefault(_playerName2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentStream = void 0;
var shouldLogStatus = void 0;
var streams = void 0;
var streamUnwrapPromise = void 0;
var wasPreviouslyPlaying = false;
var onlyHttpStreams = true;
var processCurrentStream = void 0;

function setIfLastStream(remainingStreams) {
  var stream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (remainingStreams.length === 0) {
    stream.isFinalStream = true;
  }
}

function logStreamStatus(err, duration) {
  if (!shouldLogStatus) return;
  (0, _streamStatus.reportStreamStatus)(_tuner2.default.listenId, currentStream, _tuner2.default.tune, err, duration, onlyHttpStreams);
}

function onStreamProcessSuccess(_ref) {
  var duration = _ref.duration;

  _debugger2.default.log('took ' + duration + 'ms to successfully process stream');
  logStreamStatus(null, duration); // no error to pass here, so passing null.

  _listenTime2.default.setReportStartTime();
  _tuner2.default.changeState(_tuner2.default.states.playing);
}

function onStreamProcessFailure() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // TUNE-14712: Sentry reports indicate that `error` is `null` in some cases,
  //  so adding an extra fallback here
  var errorToUse = error || {};
  var wasHlsAdvanced = (0, _get3.default)(currentStream, 'isHlsAdvanced');

  _tuner2.default.trigger(_tuner2.default.events.streamFailed);
  logStreamStatus(errorToUse);
  currentStream = streams.shift();

  if (currentStream) {
    setIfLastStream(streams, currentStream);

    var _tuner$streamPlayer$g = _tuner2.default.streamPlayer.getPlayerConfig(),
        isInstreamLoggingEnabled = _tuner$streamPlayer$g.isInstreamLoggingEnabled;

    if (wasHlsAdvanced && isInstreamLoggingEnabled) {
      (0, _logCategoryActionLabel2.default)({ action: _logging.actions.trackingURLStreamSwitch });
    }

    processCurrentStream();
  } else {
    errorToUse.failedWithHttp = onlyHttpStreams && !wasPreviouslyPlaying;
    _tuner2.default.changeState(_tuner2.default.states.failed, errorToUse);
  }
}

function onStreamsUnwrapped(response) {
  var _ref2 = currentStream || {},
      isLiveSeekStream = _ref2.isLiveSeekStream,
      isHlsAdvanced = _ref2.isHlsAdvanced;

  return _streamMapper2.default.fromUnwrapResponse((0, _get3.default)(response, 'data.streams'), {
    isLiveSeekStream: isLiveSeekStream,
    isHlsAdvanced: isHlsAdvanced
  });
}

function onError(errorData) {
  _tuner2.default.trigger(_tuner2.default.events.error, errorData);
}

function onPlayerSelected(_playerName) {
  // TODO: the InstreamAdPlayer playerName is already emitted in streamProcessor.process(). This
  //  conditional can be removed once the HLSAdvanced code in streamProcess.process() is moved to
  //  InstreamAdPlayer preload/load.
  if (_playerName !== _playerName3.default.InstreamAdPlayer) {
    _tuner2.default.trigger(_tuner2.default.events.playerSelected, _playerName);
  }
}

function processUnwrappedStreams(unwrappedStreams) {
  var stream = unwrappedStreams.shift();

  if (stream) {
    if ((0, _get3.default)(currentStream, 'isFinalStream')) {
      setIfLastStream(unwrappedStreams, stream);
    }
    onlyHttpStreams = onlyHttpStreams && (0, _isHttpStream2.default)(stream.url);

    _streamProcessor2.default.process(stream).then(onStreamProcessSuccess).catch(function () {
      processUnwrappedStreams(unwrappedStreams);
    });
  } else {
    onStreamProcessFailure(new Error('all unwrapped streams failed'));
  }
}

processCurrentStream = function processCurrentStream() {
  var _ref3 = currentStream || {},
      requiresUnwrap = _ref3.requiresUnwrap,
      url = _ref3.url;

  _tuner2.default.trigger(_tuner2.default.events.evaluateStreamStart, Date.now());

  if (requiresUnwrap) {
    var streamUnwrapRequest = (0, _streamUnwrap.unwrapStream)(url).then(function (response) {
      return onStreamsUnwrapped(response);
    }).then(processUnwrappedStreams).catch(onStreamProcessFailure);

    streamUnwrapPromise = (0, _cancelable2.default)(streamUnwrapRequest);
  } else {
    _streamProcessor2.default.process(currentStream).then(onStreamProcessSuccess).catch(onStreamProcessFailure);
  }
};

var state = {
  name: 'connecting',
  enter: function enter(previousState, context) {
    var _get = (0, _get3.default)(_tuner2.default, 'tune', {}),
        guideId = _get.guideId,
        testStreamUrl = _get.testStreamUrl,
        testStreamFormat = _get.testStreamFormat;

    var _ref4 = context || {},
        shouldLog = _ref4.shouldLogStatus,
        forceShoutcast = _ref4.forceShoutcast,
        wasPlaying = _ref4.wasPlaying;

    _tuner2.default.trigger(_tuner2.default.events.connecting, guideId);
    wasPreviouslyPlaying = wasPlaying;

    /*
      The testStreamUrl is only passed in to test single
      streams. We attempt to play the test stream and
      ignore the regular functionality.
    */
    if (testStreamUrl) {
      _tuner2.default.streams = [{
        url: testStreamUrl,
        requiresUnwrap: false,
        isFinalStream: true,
        format: testStreamFormat || 'mp3', // default for test streams
        position: 0
      }];
    }

    shouldLogStatus = shouldLog;

    // forceShoutcast is set in playing.js when stream errors out.
    // Used in streamProcessor to force shoutcast hack.
    if (forceShoutcast) {
      currentStream.forceShoutcast = true;
    } else {
      streams = (0, _cloneDeep2.default)((0, _get3.default)(_tuner2.default, 'streams', []));

      // Specify the index of the stream relative to the array of streams returned in the Tune.ashx
      // call. This will be used in the stream success/failure report.
      streams.forEach(function (stream, index) {
        stream.index = index;

        // if a stream requires unwrap then the stream.url is not the actual stream url
        // so the http check will happen in processUnwrappedStreams function
        if (!stream.requiresUnwrap) {
          onlyHttpStreams = onlyHttpStreams && (0, _isHttpStream2.default)(stream.url);
        }
      });
      currentStream = streams.shift();

      setIfLastStream(streams, currentStream);
    }

    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.error, onError);
    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.playerSelected, onPlayerSelected);

    processCurrentStream();
  },
  exit: function exit() {
    onlyHttpStreams = true;
    wasPreviouslyPlaying = false;
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.error, onError);
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.playerSelected, onPlayerSelected);
    _streamProcessor2.default.cancel();
    if (streamUnwrapPromise) streamUnwrapPromise.cancel();
  }
};

exports.default = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=connecting.js.map